<template>
  <div>
    <page-header :title="$t('winrd.nodes.page_title')" />
    <page-body>
      <el-row>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-row>
            <el-col :span="4">
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="addUpdateHandle()">
                {{$t('winrd.nodes.add')}}
              </el-button>
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="handleSearch">
                {{$t('winrd.nodes.search')}}
              </el-button>
            </el-col>
            <el-col :span="25" sortable="false">
              <el-form-item :label="$t('winrd.nodes.server_name')" prop="name" class="search-item">
                <el-input v-model="searchForm.name" style="width:200px" clearable />
              </el-form-item>
              <el-form-item :label="$t('winrd.nodes.server_ip')" prop="hostname" class="search-item">
                <el-input v-model="searchForm.hostname" style="width:200px" clearable />
              </el-form-item>
              <el-form-item :label="$t('winrd.nodes.status')" prop="is_lock" class="search-item">
                <el-select v-model="searchForm.is_lock" clearable placeholder="" style="width:180px">
                  <el-option v-for="stat in is_lock" :key="stat.id" :label="stat.name" :value="stat.id" clearable />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="dataSource" border>
          <el-table-column :label="$t('winrd.nodes.action')" width="140" align="center">
            <template slot-scope="scope">
              <div class="button-container">
                <el-button type="text" @click="updataedit(scope.row)">{{$t('winrd.nodes.edit')}}</el-button>
                <el-button type="text" @click="handleDelete(scope.$index, scope.row)">{{$t('winrd.nodes.delete')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="60px" />
          <el-table-column prop="name" :label="$t('winrd.nodes.server_name')" align="left" width="260">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <span style="margin-left: 10px;color:#e3763e;">({{$t('winrd.nodes.online_user')}}:{{ scope.row.count || 0 }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="hostname" :label="$t('winrd.nodes.server_ip')" align="left" width="150" />
          <el-table-column prop="port" :label="$t('winrd.nodes.port')" width="80" align="left" />
          <el-table-column prop="os" align="center" :label="$t('winrd.nodes.os')" width="150">
            <template slot-scope="scope">
              <el-tag> {{scope.row.os}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="admin_username" :label="$t('winrd.nodes.admin_user')" width="120" align="left" />
          <el-table-column prop="protocol" align="center" :label="$t('winrd.nodes.protocol')" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.protocol == 0">RDP</el-tag>
              <el-tag v-else type="info">VNC</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="is_lock" align="center" :label="$t('winrd.nodes.status')" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_lock == 0">{{$t('winrd.nodes.normal')}}</el-tag>
              <el-tag v-else type="info">{{$t('winrd.nodes.abnormal')}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('winrd.nodes.created_time')" align="left" width="170">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.created_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('winrd.nodes.remark')" align="left" />
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total" />
      </el-row>
    </page-body>

    <!-- 弹窗, 新增 -->
    <add-update ref="AddUpdate" @onSubmit="getDataList" />
    <!-- 弹窗, 编辑 -->
    <edit-update ref="EditUpdate" @onSubmit="getDataList" />
</div>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线
import PageBody from '~/components/PageBody/index.vue'
import PageHeader from '~/components/PageHeader/index.vue'
import AddUpdate from './add-update'
import EditUpdate from './edit-update'

export default {
  name: 'myspace',
  components: {
    PageHeader,
    PageBody,
    AddUpdate,
    EditUpdate,
  },
  data () {
    return {
      pageTitle: this.$t('winrd.nodes.page_title'),
      searchForm: { },
      is_lock: [
        { id: 0, name: this.$t('winrd.nodes.normal') },
        { id: 1, name: this.$t('winrd.nodes.abnormal') },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
    }
  },
  created () {
    // 监听事件
    eventBus.$on('refresh-list', this.fetchData)
  },
  mounted () {
    this.fetchData()
  },
  beforeDestroy () {
    // 移除事件监听
    eventBus.$off('refresh-list', this.fetchData)
  },
  methods: {
    // 列表获取
    async fetchData () {
      try {
        if (!this.pagination) {
          console.error('this.pagination is not defined')
          return
        }

        const dataRaw = {
          name: this.searchForm.name,
          hostname: this.searchForm.hostname,
          is_lock: this.searchForm.is_lock,
          page: this.pagination.currentPage,
          per_page: this.pagination.pageSize,
        }

        const response = await this.$axios.get('/api/sa/rdbackend/list_remote_hosts', {
          params: dataRaw,
        })

        const overViewListData = response.data
        this.dataSource = overViewListData.remote_hosts || []
        console.log('this.dataSource', this.dataSource)
        this.pagination.total = overViewListData.count || 0
        this.pagination.currentPage = overViewListData.page || 1

        // 获取每个服务器的请求接口数量
        await this.fetchApiCounts()
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    // 获取每个服务器的请求接口数量
    async fetchApiCounts () {
      try {
        const response = await this.$axios.get('/api/sa/rdbackend/connections')
        const res = response.data.data
        for (let i = 0; i < this.dataSource.length; i++) {
          const item = this.dataSource[i]
          for (let j = 0; j < res.length; j++) {
            if (item.name === res[j].name) {
              this.$set(item, 'count', res[j].count)
            }
          }
        }
      } catch (error) {
        console.error('There was an error fetching API counts!', error)
      }
    },

    // 查询
    handleSearch () {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 分页
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.pagination.pageSize = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    handleCurrentChange (val) {
      // 改变默认的页数
      this.pagination.currentPage = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    // 新增
    addUpdateHandle (row) {
      this.$refs.AddUpdate.init({ ...row }, this.appTypeList)
    },

    // 编辑
    updataedit (row) {
      this.$refs.EditUpdate.init({ ...row }, this.appTypeList)
      console.log('row', row)
    },

    // 删除服务器
    handleDelete (idx, row) {
      MessageBox(this.$t('winrd.nodes.delete_confirm', { user: row.hostname }), this.$t('winrd.nodes.tips'), {
        confirmButtonText: this.$t('winrd.nodes.confirm'),
        cancelButtonText: this.$t('winrd.nodes.cancel'),
        type: 'warning',
      }).then(() => {
        const params = {
          hostname: row.hostname,
          action: 'delete',
        }

        this.$axios.post('/api/sa/rdbackend/delete_remote', params, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(resp => {
          this.fetchData() // 更新列表
          if (resp.data.code === 200) {
            const message = resp.data.message
            Message({
              message,
              type: 'success',
            })
          } else {
            Message({
              message: this.$t('winrd.nodes.delete_failed', { msg: resp.data.resultinfo.errmsg }),
              type: 'error',
            })
          }
        }).catch(error => {
          console.error('Error deleting user:', error)
          Message({
            message: this.$t('winrd.nodes.delete_failed', { msg: error.message }),
            type: 'error',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('winrd.nodes.delete_cancel'),
        })
      })
    },

    // 转换时间戳
    formatTimestamp (timestamp) {
      if (timestamp) {
        const date = new Date(timestamp * 1000) // 将秒转换为毫秒
        return date.toLocaleString() // 返回本地化的日期和时间字符串
      }
      return ''
    },
  },
}
</script>

<style scoped>
body,html{
  min-width: 1280px;
}
.el-table thead{
  color: #333 !important;
  font-weight: bold !important;
}
.el-button{
  float: left;
  margin-right: 10px;
}
.el-tag {
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-tag:last-child {
  margin-right: 0;
  margin-bottom: 0;
}
.el-tag{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.el-tag.el-tag--info{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.button-container .el-button {
  margin: 0 5px; /* 可选：为按钮添加一些间距 */
}
</style>
